import { render, staticRenderFns } from "./vd.vue?vue&type=template&id=01287c20&"
import script from "./vd.vue?vue&type=script&lang=js&"
export * from "./vd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports